export function getRandomNumberInRange({
  min,
  max,
  seed,
}: {
  min: number
  max: number
  seed?: number
}): number {
  if (seed == null) {
    return Math.random() * (max - min) + min
  }

  // LCG parameters (from glibc)
  const a = 1103515245
  const c = 12345
  const m = 2147483648 // 2^31

  // Generate a value between 0 and 1 using the seed
  const normalized = ((a * seed + c) % m) / m

  // Scale to the desired range
  return normalized * (max - min + 1) + min
}
